export function getAttr(el, attr) {
  return el.getAttribute(attr);
}


//////////////////
// WEBPACK FOOTER
// ../work/src/~/tiny-slider/src/helpers/getAttr.js
// module id = 35
// module chunks = 0